/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AnalyticsSignalSelection = {
  /**
   * Zero-based ordered level; matches cumulative probability at or above this level
   */
  minimumLevel?: number | undefined;
  sensorId: string;
  /**
   * For multi-label or exclusive results; omit when minimum_level is set
   */
  signalId?: string | undefined;
  /**
   * Explicit probability threshold greater than zero. Exclusive results use the selected signal instead.
   */
  threshold: number;
};

/** @internal */
export const AnalyticsSignalSelection$inboundSchema: z.ZodMiniType<
  AnalyticsSignalSelection,
  unknown
> = z.pipe(
  z.object({
    minimum_level: z.optional(z.int()),
    sensor_id: z.string(),
    signal_id: z.optional(z.string()),
    threshold: z.number(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "minimum_level": "minimumLevel",
      "sensor_id": "sensorId",
      "signal_id": "signalId",
    });
  }),
);
/** @internal */
export type AnalyticsSignalSelection$Outbound = {
  minimum_level?: number | undefined;
  sensor_id: string;
  signal_id?: string | undefined;
  threshold: number;
};

/** @internal */
export const AnalyticsSignalSelection$outboundSchema: z.ZodMiniType<
  AnalyticsSignalSelection$Outbound,
  AnalyticsSignalSelection
> = z.pipe(
  z.object({
    minimumLevel: z.optional(z.int()),
    sensorId: z.string(),
    signalId: z.optional(z.string()),
    threshold: z.number(),
  }),
  z.transform((v) => {
    return remap$(v, {
      minimumLevel: "minimum_level",
      sensorId: "sensor_id",
      signalId: "signal_id",
    });
  }),
);

export function analyticsSignalSelectionToJSON(
  analyticsSignalSelection: AnalyticsSignalSelection,
): string {
  return JSON.stringify(
    AnalyticsSignalSelection$outboundSchema.parse(analyticsSignalSelection),
  );
}
export function analyticsSignalSelectionFromJSON(
  jsonString: string,
): SafeParseResult<AnalyticsSignalSelection, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnalyticsSignalSelection$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnalyticsSignalSelection' from JSON`,
  );
}
